const colors = {
  // GRAY
  'gray-95': '#1d192b',
  'gray-50': '#79747e',
  'gray-40': '#49454f',
  'gray-30': '#9ca3af',
  'gray-15': '#e7e0ec',
  'gray-10': '#f4f4f6',
  'gray-5': '#fffbfe',
  'gray-subtitle': '#1C1B1F',
  'gray-cac': '#cac4d0',

  // BLUE
  'blue-bb': '#1856ff',
  'blue-30': '#51b4c7',
  'blue-10': '#e3eafc',

  // YELLOW
  'yellow-bb': '#fdfc30',

  // PURPLE
  'purple-50': '#683CB8',
  'purple-10': '#e7e0ec',

  // GREEN
  'green-40': '#54a852',

  // RED
  'red-border': '#b3261e',
  'red-60': '#db2f6b',

  // WHITE
  'white-bb': '#FFF',

  // BLACK
  'black-bb': '#1D192B',
  'black-title-bb': '#49454F',

  // Figma
  'light-on-surface': '#1C1B1F',
  'light-on-surface-variant': '#49454F',
  'sys-light-surface': '#FFFBFE',
  'sys-light-surface-variant': '#E7E0EC'
}

export default colors
